import { addDays, format } from "date-fns";
import { usePractice } from "../usePractice";
import { Helmet } from "react-helmet-async";
import { getBrand } from "../utils/brand";

const SHOPIFY_URL = process.env.REACT_APP_SHOPIFY_URL;

function PostAquamationSelection({
  caseData,
  dateWithinThreeDays,
  dateWithinSevenDays,
}) {
  const { practice } = usePractice();
  const brand = getBrand(practice?.fields?.brand);
  return (
    <>
      <Helmet>
        <title>{brand.name} - Thank You</title>
      </Helmet>

      <div className="container">
        {!dateWithinThreeDays &&
        caseData.fields.aquamationType === "Undecided" ? ( // customer did not decide within 3d, default to RR + RI
          <p>
            Since we did not receive an aquamation type within three days, we
            have defaulted to Remains Returned, which includes remembrance
            items. Please contact the {brand.name} team with any questions by
            phone at {brand.phoneNumber} or email at {brand.supportEmail}.
          </p>
        ) : (
          <>
            <p>
              <strong>Pet Name: </strong>
              {caseData.fields.petName}
            </p>
            <p>
              <strong>Aquamation Type: </strong>
              {caseData.fields.aquamationType}
            </p>
            <p>
              Thank you for your selection. Please contact the {brand.name} team
              with any questions by phone at {brand.phoneNumber} or email at
              {brand.supportEmail}.
            </p>
            {caseData.fields.aquamationType === "Remains Returned" &&
              dateWithinSevenDays && (
                <p>
                  <strong>Urn Options:</strong> In addition to our complimentary
                  scatter vessel, we have thoughtfully handpicked a selection of
                  urns for purchase. Some of our vessels are functional, others,
                  timeless, but all are beautiful. You can visit our{" "}
                  <a href={`${SHOPIFY_URL}/?cid=${caseData.id}`}>store</a> to
                  browse our current urn offerings. All urn sizes are listed by
                  weight. The size you select should be based on your loved
                  one's healthiest weight throughout their life, not what they
                  weighed at the time of their passing as many pets can gain or
                  lose weight. If you prefer the complimentary scatter vessel
                  urn there is no need to purchase one from our online store.
                </p>
              )}
            {dateWithinThreeDays &&
              !caseData.fields.excludeRemembranceItems && (
                <p>
                  <strong>Remembrance Items:</strong> You may purchase
                  additional remembrance item capturing at our{" "}
                  <a href={`${SHOPIFY_URL}/?cid=${caseData.id}`}>store.</a> Clay
                  paw impressions, ink paw prints and fur clippings can be
                  selected until{" "}
                  <strong>
                    {`${format(
                      addDays(new Date(caseData.createdTime), 3),
                      `MMMM do`
                    )}`}
                  </strong>
                  . For special requests or customizations please reach out to
                  us by phone at {brand.phoneNumber} or email at
                  {brand.supportEmail}.
                </p>
              )}
          </>
        )}
      </div>
    </>
  );
}

export default PostAquamationSelection;
